// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";
import { onSetSelectedClient } from "../actions";
import { getDashboardsByAccess } from "../../utils/helpers";
import { handleApiError } from "../../utils/errorHandling";
import { assignPageFilters } from "./analytics";

// ----------------------------------------------------------------------

export const initialState = {
  error: null,
};

const slice = createSlice({
  name: "locusDashboards",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getAvailableDashboardsSuccess(state, action) {
      for (const [key, dashboard] of Object.entries(action.payload)) {
        state[dashboard?.id] = dashboard;
      }
      // const nextState = { ...state };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(onSetSelectedClient, (state, action) => {})
      .addDefaultCase((state, action) => {});
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getAvailableDashboards({
  analyticsSection = "dashboards",
  selectedSiteId,
  activeUser = null,
}) {
  return async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/analytics/analytics/dashboard`,
        { type: analyticsSection },
        {},
      );

      const rows = assignPageFilters(response?.data?.rows);

      let _availableDashboards = [];
      if (selectedSiteId && response?.data?.count > 0) {
        _availableDashboards = getDashboardsByAccess(
          { ...response?.data, rows },
          analyticsSection,
          { id: selectedSiteId },
          activeUser,
        );
      }

      dispatch(
        slice.actions.getAvailableDashboardsSuccess({
          ..._availableDashboards,
        }),
      );
      return { ...response, data: { ...response?.data, rows } };
    } catch (error) {
      handleApiError(error, dispatch, slice.actions.hasError);
    }
  };
}
